<template>
    <i class="messages huge ico-notification pointer dark" @click.self="toggleOpenClose">
        <!-- v-click-outside="close" -->

        <span class="number bold text-center lightest bg-brand" @click.self="toggleOpenClose" v-if="unreadNotificationsNr > 0">{{ unreadNotificationsNr > 9? '9+' : unreadNotificationsNr }}</span>

        <div v-if="getIsBellNotificationOpen" class="box cursor-default">
            <div class="wrapper pb-0">
                <h5 class="d-flex mb-0 justify-content-between">
                    <div class="d-flex flex-grow-1">Notifications</div>
                    <div class="mr-3 pointer normal color-1" @click="markAllNotificationsRead">Mark all as read</div>
                    <i class="fas fa-sync pointer" :class="{'opacity-50 spin':getIsFetchingNotifications}" @click="reloadNotifications"></i>
                </h5>
            </div>


            <div class="list m-0" @scroll="notificationsScoll">
                <default-Notification
                    v-if="notifications.length > 0"
                    v-for="item in notifications"
                    :key="item.id"
                    :notification="item"
                    :options="notificationOptions"
                    class="border-bottom-medium"
                    @click=""
                    @deleteNotification="deleteNotification($event)"
                    @notificationClicked="">
                </default-Notification>
                <div v-if="isLoading" class="text-center p-3" style="height:40px;">
                    <loader />
                </div>
            </div>


            <div v-if="!isLoading && notifications.length < 1" class="text-center pb-4 pt-2" >
                <p>No notifications.</p>
            </div>

            <div class="options bg-faded border-top-light d-flex justify-content-center">
                <!-- <div class="pointer" @click="markAllNotificationsRead">Mark all as read</div> -->
                <div class="pointer color-1" @click="viewAll">View all</div>
            </div>
        </div>
    </i>
</template>

<script>
    import defaultNotification from './notifications/default'
    import { mapGetters, mapActions } from 'vuex'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function() {
            return {
                // isVisible: false,
                pagination:{
                    currentPage: 0,
                    pageSize: 10,
                },
                // downloadedNotifications: [],
                notificationOptions: {
                    markAsReadOnClick: true,
                }
            }
        },
        computed: {
            ...mapGetters([
                'getIsBellNotificationOpen',
                'getNotifications',
                'getUnreadNotificationsNr',
                'getIsFetchingNotifications',
                'getUnviewedNotificationsCount',
                'getIsFetchingAllNotifications',
                'getBellNotificationList'
            ]),
            isLoading: function() {
                return this.getIsFetchingAllNotifications
            },
            notifications: function() {
                return this.getBellNotificationList
            },
            unreadNotificationsNr: function() {
                return this.getUnviewedNotificationsCount
            }
        },
        methods: {
            ...mapActions([
                'toggleBellNotificationPopup',
                'fetchNotifications',
                'markNotificationAsRead',
                'markAllNotificationsRead',
                'fetchUnviewdNotificationsCount',
                'setNotificationsAsViewed',
                'setBellNotificationList',
            ]),
            toggleOpenClose: function(){
                if(this.getIsBellNotificationOpen){
                    this.close()
                } else {
                    this.open()
                }
            },
            open: function() {
                // this.isVisible = true;
                this.toggleBellNotificationPopup(true)
                if(this.pagination.currentPage == 0){
                    this.downloadNotifications()
                }
            },
            close: function(e) {
                // this check is need because this method "close" is called everytime we click somewhere in the app :\
                if(this.getIsBellNotificationOpen){
                    // count how many notifications will be marked as viewed
                    // let unviewedNotificationIds = this.downloadedNotifications.filter(n=>{return n.markedAsViewed == false}).map(n2 => {return n2.id})
                    // let notificationsWillBeViwedCount = unviewedNotificationIds.length

                    this.setNotificationsAsViewed(this.getBellNotificationList)
                    // this.isVisible = false;
                    this.toggleBellNotificationPopup(false)
                }
            },
            deleteNotification: function (notification) {
                let notificationIndex = this.getBellNotificationList.indexOf(this.getBellNotificationList.find(n => {return n.id == notification.id}))
                this.getBellNotificationList.splice(notificationIndex, 1)
                this.setBellNotificationList(this.getBellNotificationList)
            },
            reloadNotifications: function () {
                this.pagination.currentPage = 0
                // this.downloadedNotifications = []
                this.setBellNotificationList([])
                this.fetchUnviewdNotificationsCount()
                this.downloadNotifications()
            },
            downloadNotifications: function () {
                this.pagination.currentPage++
                this.fetchNotifications({pagination: this.pagination}).then(response => {
                    this.setBellNotificationList(this.getBellNotificationList.concat(response.result))
                    // this.downloadedNotifications = this.downloadedNotifications.concat(response.result)
                })
            },
            markRead: function(notification) {
                this.markNotificationAsRead(notification)
            },
            viewAll: function () {
                this.$router.push({ name: 'notifications' })
                this.close()
            },
            notificationsScoll: function (e) {
                let distanceFromTop = e.srcElement.scrollTop
                let bottom = e.srcElement.scrollHeight - e.srcElement.offsetHeight

                //reach bottom now download more notifications
                if(distanceFromTop + 5 >= bottom && this.isLoading == false){
                    this.downloadNotifications()
                }
            }
        },
        components: {
            defaultNotification,
            Loader
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .list{

        li:hover{
            background-color: $lighter
        }

        max-height: 60vh;
        overflow: auto;

        .details {
            position: relative;

            .markRead{
                display: none;
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        .details:hover {
            .markRead{
                display: inline;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// Notifications.vue?18fd029e